import { useForm } from "react-hook-form";
import { AnswerInput } from "../AnswerInput";
import { MultipleAnswerInput } from "../MultipleAnswerInput";
import { CheckboxListInput } from "../CheckboxListInput";
import { useEffect, useRef } from "react";

export const Step7 = ({ questions = [], answers = {}, updateAnswer }) => {



  const defaultValues = questions.reduce((acc, question) => {
    if (!question.allow_multiple_answers) {
      acc[String(question.id)] =
        answers[question.id] || question?.answer?.answer_text || "";
    }
    return acc;
  }, {});

  const { control, setValue } = useForm({
    defaultValues,
  });

  const prevAnswersRef = useRef(answers);

  useEffect(() => {
    questions.forEach((question) => {
      if (!question.allow_multiple_answers) {
        const questionId = String(question.id);
        const currentAnswer = answers[question.id];
        const prevAnswer = prevAnswersRef.current[question.id];

        if (currentAnswer !== prevAnswer && currentAnswer !== undefined) {
          setValue(questionId, currentAnswer, { shouldDirty: false });
        }
      }
    });

    prevAnswersRef.current = { ...answers };
  }, [answers, questions, setValue]);

  // Get options from question ID 19 for checkbox list
  const getOptionsFromQuestion19 = () => {
    const answer19 = answers[18]; //fixed question id for production but in uat/staging it is 19

    // If answer exists and is an array, use it
    if (Array.isArray(answer19) && answer19.length > 0) {
      return answer19;
    }

    // Try to parse from question.answer.answer_text if available
    const question19 = questions.find((q) => q.id === 19);
    if (question19?.answer?.answer_text) {
      try {
        const parsed = JSON.parse(question19.answer.answer_text);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch {
        // If parsing fails, return empty array
      }
    }

    return [];
  };

  return (
    <div className="d-flex flex-column w-full" style={{ gap: "24px" }}>
      {questions?.length > 0 &&
        questions.map((question) => {
          const options = getOptionsFromQuestion19();

          // Get defaultValue - should be an array
          let defaultValue = answers[question.id];

          // If not in answers, try to parse from question.answer.answer_text
          if (!defaultValue && question?.answer?.answer_text) {
            try {
              const answerText = question.answer.answer_text;
              if (
                typeof answerText === "string" &&
                answerText.trim().startsWith("[")
              ) {
                defaultValue = JSON.parse(answerText);
              } else if (answerText) {
                defaultValue = [answerText];
              } else {
                defaultValue = [];
              }
            } catch {
              defaultValue = [];
            }
          }

          // Ensure it's an array
          if (!Array.isArray(defaultValue)) {
            defaultValue = [];
          }

          return (
            <CheckboxListInput
              key={question.id}
              label={question.question_text}
              options={options}
              defaultValue={defaultValue}
              onValueChange={(value) => {
                if (updateAnswer) {
                  updateAnswer(question.id, value);
                }
              }}
            />
          );
        })}
    </div>
  );
};
